<template>
    <v-card>
        <v-btn icon small class="notifications-close-x" @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="headline" style="border-bottom-style: outset;border-bottom-width: 1px;"> Notificaciones </v-card-title>
        <template v-if="notifications.length > 0">
            <app-modal-row  v-for="noti in notifications" style="border-bottom-style: outset;border-bottom-width: 1px;">
                <app-modal-col cols='11'>

                    <v-card-text>
                    <b style="font-size:large">  {{noti.subject}} </b> <br><br>
                        <div v-html="noti.date"></div>
                        <div v-html="cleanMessage(noti.message)"></div>
                        <div v-if="hasAcceptButton(noti)" class="mt-3">
                            <v-btn color="primary"
                                   :loading="accept_loading.includes(noti.id)"
                                   @click="accept_policy(noti)"
                            >
                                Aceptar nueva política
                            </v-btn>
                            <v-btn v-if="acceptDocIds(noti).length"
                                   text
                                   color="primary"
                                   class="ml-2"
                                   :loading="docs_loading"
                                   @click="openLegalDocs(noti)"
                            >
                                Leer Términos Completos
                            </v-btn>
                        </div>
                    </v-card-text>
                </app-modal-col>
                <app-modal-col cols='1'>
                    <v-btn @click="delete_noti(noti.id)"
                            icon 
                            large
                            style="bottom:-10px"
                            color="primary"
                            :loading="loading.includes(noti.id)"
                            >
                        Leído
                    </v-btn>
                </app-modal-col>
            </app-modal-row>
        </template>
        <template v-else>
            <v-card-text>
                No hay notificaciones.
            </v-card-text>
        </template>
        <v-dialog v-model="legal_docs_dialog" max-width="900" scrollable>
            <v-card>
                <v-toolbar dark color="primary" flat>
                    <v-toolbar-title>Documentación legal</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="legal_docs_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-6" style="max-height: 70vh;">
                    <div v-for="doc in legal_docs" :key="doc.id" class="mb-8">
                        <h3 class="mb-3">{{ doc.name }}</h3>
                        <div v-html="doc.content"></div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>

import { mapActions, mapGetters } from "vuex";
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "../store/vuex_utils";
import { user as api_user } from "@/api/user";
import { client } from "@/api/client";
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';

export default {
    name: 'NotificationsPopup',
    components: {
        AppModalCol,
        AppModalContainer,
        AppModalRow
    },
    props: {

    },
    data () {
        return {
            loading:[],
            accept_loading:[],
            legal_docs_dialog: false,
            legal_docs: [],
            docs_loading: false,
        }
    },
    methods: {
        ...mapActions({
            removeNotification: "notifications/removeNotification",
            setUserData: "me/setUserData",
        }),

        delete_noti(noti_id){
            this.loading.push(noti_id)
            let user_id = this.userData.user
            this.removeNotification({user_id,noti_id})
            this.loading = this.loading.filter(i => i !== noti_id)
        },
        hasAcceptButton(noti) {
            // Marcador que convierte esta notificación concreta en una
            // aceptación activa (botones "Aceptar nueva política" y
            // "Leer Términos Completos"). El resto de notificaciones se
            // renderizan y funcionan como siempre.
            // Formato: [BOTON_ACEPTAR] o [BOTON_ACEPTAR:3,5] (ids de LegalContract)
            return noti.message && noti.message.includes('[BOTON_ACEPTAR');
        },
        acceptDocIds(noti) {
            const m = (noti.message || '').match(/\[BOTON_ACEPTAR(?::([\d,]+))?\]/);
            if (!m || !m[1]) return [];
            return m[1].split(',').map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id));
        },
        cleanMessage(message) {
            return (message || '').replace(/\[BOTON_ACEPTAR(?::[\d,]+)?\]/, '');
        },
        async accept_policy(noti) {
            this.accept_loading.push(noti.id)
            try {
                const response = await api_user.setUserInfo({ policy_accepted: true });
                this.setUserData(response.data.results);
                let user_id = this.userData.user
                await this.removeNotification({user_id, noti_id: noti.id})
                this.$emit('close');
            } catch (error) {
                console.error(error);
            } finally {
                this.accept_loading = this.accept_loading.filter(i => i !== noti.id)
            }
        },
        async openLegalDocs(noti) {
            this.docs_loading = true
            try {
                const ids = this.acceptDocIds(noti);
                const responses = await Promise.all(ids.map(id => client.get(`get_legal_contract/${id}`)));
                this.legal_docs = responses.map(r => r.data);
                this.legal_docs_dialog = true;
            } catch (error) {
                console.error(error);
            } finally {
                this.docs_loading = false
            }
        }
    },
    computed: {
        ...mapFields('notifications', ['notifications']),
        ...mapGetters({userData: 'me/userData'})
        
    },
}
</script>

<style lang="scss" scoped>

.notifications-close-x {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
}

span.title {
    color: #66369b
}

.plans {
    cursor: pointer;
    font-size: 0.80rem;
    background-color:white;
    &.selected {
        background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
    }
    &.disabled {
        opacity: 50%;
    }
    span {
        margin: auto;
    }
    border: 1px solid #66369b;
}
button.btn-purple {
    color: #ffffff;
}


p.contract-date {
    color: #66369b;
    font-weight: 500;
    font-size: 0.9rem;
    text-align: left;
}


.small-font {
    font-size: 0.80rem;
}

.promotional_code fieldset {
    color: white !important;
}


</style>